<div class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
  <div
    class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
    <form [formGroup]="companyForm" (ngSubmit)="onSave()">
      <h1 class="heading">
        Add
      </h1>
      <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="grid gap-4 sm:grid-cols-2">
        <!-- name -->
        <div class="space-y-1">
          <label class="subheading after:text-red-600 after:content-['*']">
            Name
          </label>
          <div>
            <div>
              <input [readonly]="companyId" formControlName="CompanyName" type="text" />
            </div>
            <div *ngIf="submitted && form.CompanyName.errors">
              <p *ngIf="form.CompanyName.errors.required" class="pt-1 text-red-600 text-xs">
                Company Name is required
              </p>
            </div>
          </div>
        </div>
      
        
        <!-- address -->
        <ng-container formGroupName="CompanyAddr">

          <div class="space-y-1">
            <label class="subheading after:text-red-600 after:content-['*']">
              Line 1
            </label>
            <div>
              <div>
               
                <input  formControlName="Line1"  googlePlace (onSelect)="onSelectAddress($event)" name="address"
                  placeholder="Enter the address" id="address" type="text" />
              </div>
             

            </div>
          </div>

             <div class="space-y-1">
            <label class="subheading after:text-red-600 after:content-['*']">
              Line 2 
            </label>
            <div>
              <div>
                 <!-- googlePlace (onSelect)="onSelectAddress($event)" -->
                <input formControlName="Line2" name="address"
                  placeholder="Enter the address" id="address" type="text" />
              </div>
           

            </div>
          </div>

          <!-- City -->
          <div class="space-y-1">
            <label class="subheading after:text-red-600 after:content-['*']">
              City 
            </label>
            <div>
              <div>
                <input formControlName="City" name="City" id="City" type="text" />
              </div>
              <div *ngIf="submitted && (address.get('City')?.errors || address.get('coords')?.errors)">
                <p *ngIf="address.get('City')?.errors?.required || address.get('coords')?.errors?.required"
                  class="pt-1 text-red-600 text-xs">
                  City is required
                </p>
              </div>

            </div>
          </div>

          <!-- CountrySubDivisionCode -->
          <div class="space-y-1">
            <label class="subheading after:text-red-600 after:content-['*']">
              Country Sub Division Code 
            </label>
            <div>
              <div>
                <input formControlName="CountrySubDivisionCode" name="CountrySubDivisionCode" id="CountrySubDivisionCode" type="text" />
              </div>
             

            </div>
          </div>

          <!-- PostalCode -->
          <div class="space-y-1">
            <label class="subheading after:text-red-600 after:content-['*']">
              Postal Code
            </label>
            <div>
              <div>
                <input formControlName="PostalCode" name="PostalCode" id="PostalCode" type="text" />
              </div>
             

            </div>
          </div>

          <!-- Country -->
          <div class="space-y-1">
            <label class="subheading after:text-red-600 after:content-['*']">
            Country
            </label>
            <div>
              <div>
                <input formControlName="Country" name="Country" id="Country" type="text" />
              </div>
            </div>
          </div>
        </ng-container>

      </section>

      <h2 class="subheading mt-4">Reference</h2>
      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="grid gap-4 sm:grid-cols-2" formGroupName="reference">
        <div class="space-y-1">
          <label class="subheading">
            Name
          </label>
          <div>
            <input formControlName="name" name="name" id="name" type="text" />
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            ID
          </label>
          <div>
            <input formControlName="id" name="referenceId" id="referenceId" type="text" />
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            URL
          </label>
          <div>
            <input formControlName="url" name="url" id="url" type="text"
              placeholder="https://example.com/api/v1/quickbooks/webhook" />
          </div>
        </div>
      </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="grid gap-4 sm:grid-cols-2">
        <div class="space-y-1">
          <label class="subheading">Auto Sync</label>
          <div class="flex items-center mt-6 space-x-2">
            <label
              class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
              <input type="checkbox" formControlName="isAutoSync" class="peer sr-only" (change)="toggleAutoSync($event)" />
              <span
                class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                <span *ngIf="!companyForm.get('isAutoSync')?.value"
                  class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                  aria-hidden="true">
                  <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                    <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <span *ngIf="companyForm.get('isAutoSync')?.value"
                  class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                  aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="h-3 w-3 text-white">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                  </svg>
                </span>
              </span>
            </label>
          </div>
          <p class="pt-2 text-xs text-zinc-500">Push invoices, bills, customers, and vendors to QuickBooks automatically on create/update.</p>
        </div>
        <div class="space-y-1">
          <label class="subheading">Auto Bill Pay</label>
          <div class="flex items-center mt-6 space-x-2">
            <label
              class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
              <input type="checkbox" formControlName="isAutoBillPay" class="peer sr-only" (change)="toggleAutoBillPay($event)" />
              <span
                class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                <span *ngIf="!companyForm.get('isAutoBillPay')?.value"
                  class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                  aria-hidden="true">
                  <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                    <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <span *ngIf="companyForm.get('isAutoBillPay')?.value"
                  class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                  aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="h-3 w-3 text-white">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                  </svg>
                </span>
              </span>
            </label>
          </div>
          <p class="pt-2 text-xs text-zinc-500">Requires Auto Sync. After a bill is in QuickBooks, create a Bill Payment with the Payment Account below. This does not send a bank transfer.</p>
        </div>
      </section>
      <section class="grid gap-4 sm:grid-cols-2 mt-4" *ngIf="companyForm.get('isAutoBillPay')?.value">
        <ng-container formGroupName="billPayAccount">
          <div class="space-y-1">
            <label class="subheading after:text-red-600 after:content-['*']">Payment Account</label>
            <div class="flex items-center gap-3">
              <div class="relative flex-1">
                <select formControlName="value" (change)="onPayAccountChange($event)" class="pr-10" [disabled]="!companyId">
                  <option value="">Select a bank/credit account</option>
                  <option *ngFor="let account of accounts" [value]="account.Id">
                    {{ account.Name }}
                  </option>
                </select>
                <svg class="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              <div *ngIf="selectedPayAccount"
                class="w-44 rounded-lg border px-3 py-1.5 text-sm font-medium"
                [ngClass]="(selectedPayAccount.CurrentBalance || 0) < 0
                  ? 'bg-pink-50 border-pink-200 text-pink-700 dark:bg-pink-400/10 dark:border-pink-400/20 dark:text-pink-300'
                  : 'bg-green-50 border-green-200 text-green-700 dark:bg-green-400/10 dark:border-green-400/20 dark:text-green-300'">
                {{ (selectedPayAccount.CurrentBalance || 0) | currency:'USD':'symbol':'1.2-2' }}
              </div>
            </div>
            <p class="pt-2 text-xs text-zinc-500" *ngIf="!companyId">Save the company and connect QuickBooks, then edit to choose a Payment Account.</p>
            <p class="pt-2 text-xs text-zinc-500" *ngIf="companyId && !accounts?.length">No payment accounts found for this company.</p>
          </div>
        </ng-container>
      </section>
      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

      <section class="flex justify-end gap-4">
        <button type="submit" class="btn btn-secondary">
          Save
        </button>
      </section>
      
    </form>
  </div>
</div>